import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { IPageHeader } from '../../../../Components/pageheader/pageHeader.model';
import { PageheaderComponent } from '../../../../Components/pageheader/pageheader.component';
import { CommonModule } from '@angular/common';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { ArticlesViewComponent } from '../../../../Components/articles-view/articles-view.component';
import { BaseComponent } from '../../../base.component';
import { IPopup } from '../../../../Components/popup/popup.model';
import { AutoUnsubscribe } from '../../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../../Services/schoolApi.service';
import {
  DOMAIN_TYPE,
  NATIONAL_PAGES,
  SCHEMA_TYPE,
} from '../../../../constants';
import { IList } from '../../../../Models/list.model';
import { IResponse } from '../../../../Models/response.model';
import { ISchoolArticle } from '../../../../Models/schoolArticle.model';

@AutoUnsubscribe()
@Component({
  selector: 'app-art',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    ArticlesViewComponent,
    PageheaderComponent,
  ],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './art.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArtComponent extends BaseComponent {
  public pageOptions: IPageHeader = {
    mainPage: { title: 'activities', path: '/activities' },
    children: [{ title: 'art', path: null }],
  };
  public musicArticlesArray: IPopup[] = [];
  public drawingArticlesArray: IPopup[] = [];

  public musicStart: number = 1;
  public musicLimit: number = 5;
  public musicTotalcount: number;

  public drawingStart: number = 1;
  public drawingLimit: number = 5;
  public drawingTotalcount: number;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.NATIONAL;
    this.schemaType = SCHEMA_TYPE.ARTICLE;
  }

  ngOnInit(): void {
    this.onMusicPaginateEvent(0);
    this.onDrawingPaginateEvent(0);
  }

  onMusicPaginateEvent($event: number) {
    this.musicStart = $event;
    this.articleType = NATIONAL_PAGES.ACTIVITIES.ART.MUSIC;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.musicStart,
        limit: this.musicLimit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.musicTotalcount = data.payload?.count || 0;
          this.musicArticlesArray = this.mapArticles(data.payload?.list || []);
          this.cdr.detectChanges();
        }
      });
  }

  onDrawingPaginateEvent($event: number) {
    this.drawingStart = $event;
    this.articleType = NATIONAL_PAGES.ACTIVITIES.ART.DRAW;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.drawingStart,
        limit: this.drawingLimit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.drawingTotalcount = data.payload?.count || 0;
          this.drawingArticlesArray = this.mapArticles(
            data.payload?.list || []
          );
          this.cdr.detectChanges();
        }
      });
  }
}
